<template>
  <!-- 专题管理 -->
  <div class="page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <!-- 筛选 -->
        <div class="screening_box">
          <div>
            <ul>
              <li style="margin:0">
                <el-input
                  v-model="screenData.ruleId"
                  placeholder="请输入专题id"
                  clearable
                  @change="screening"
                ></el-input>
              </li>
              <li style="margin:0">
                <el-input
                  v-model="screenData.ruleName"
                  placeholder="请输入专题名称"
                  clearable
                  @change="screening"
                ></el-input>
              </li>
              <li>
                <el-date-picker
                  v-model="date"
                  class="date_box"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="selectDate"
                ></el-date-picker>
              </li>
              <li>
                <el-select
                  v-model="screenData.companyid"
                  filterable
                  :disabled="!isAdmin"
                  placeholder="请选择公司"
                  @change="selectCompany"
                >
                  <el-option
                    :label="company.companyname"
                    :value="company.companyid"
                    v-for="company in search_companyList"
                    :key="company.companyid"
                  ></el-option>
                </el-select>
              </li>
            </ul>
            <ul>
              <li>
                <span>接口取数:</span>
                <el-select
                  class="selectBox"
                  v-model="screenData.sunordergather"
                  placeholder="请选择"
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <span>取转发:</span>
                <el-select
                  class="selectBox"
                  v-model="screenData.weiboRepost"
                  placeholder="请选择"
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in options3"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <span>过滤垃圾:</span>
                <el-select
                  class="selectBox"
                  v-model="screenData.isFilterAD"
                  placeholder="请选择"
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <span>关键词匹配转发:</span>
                <el-select
                  class="selectBox"
                  v-model="screenData.repostStatus"
                  placeholder="请选择"
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <span>回采结束状态:</span>
                <el-select
                  class="selectBox"
                  v-model="screenData.endGatherDate"
                  placeholder="请选择"
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in options2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <span>运行状态:</span>
                <el-select
                  class="selectBox selectBox2"
                  v-model="screenData.status"
                  placeholder="请选择"
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <span>字符:</span>
                <el-select
                  class="selectBox selectBox2"
                  v-model="screenData.character"
                  placeholder="请选择"
                  clearable
                  @change="selectScrenn"
                >
                  <el-option
                    v-for="item in stringArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 专题列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="专题" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{ scope.row.ruleName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开始/结束时间" width="160">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.startTime + ' 至 ' + scope.row.endTime"
                placement="top"
              >
                <span style="font-size:12px;cursor: default;">
                  {{ scope.row.startTime.slice(5, 10) }}
                  ~
                  {{ scope.row.endTime.slice(5, 10) }}
                </span>
              </el-tooltip>
              <i
                class="el-icon-edit edit_icon"
                @click="editEndTime(scope.row)"
              ></i>
            </template>
          </el-table-column>
          <el-table-column label="运行状态">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                changeStatus(scope.row.status)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="回采状态">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                scope.row.endGatherDate == 1 ? "未结束" : "结束"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="接口取数">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                scope.row.sunordergather == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="取转发">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                scope.row.weiboRepost == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="过滤垃圾">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                scope.row.isFilterAD == 1 ? "是" : "否"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="关键词匹配转发">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                scope.row.repostStatus == 0 ? "否" : "是"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{
                companyList[scope.row.companyId]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建人" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span style="font-size:12px;">{{ scope.row.userId }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                :content="scope.row.addOn"
                placement="top"
              >
                <p style="font-size:12px;cursor: default;white-space: nowrap;">
                  {{ scope.row.addOn.slice(5, 16) }}
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="80" label="操作">
            <template slot-scope="scope">
              <div class="btn_box">
                <el-button class="btn" size="mini" @click="lookTopic(scope.row)"
                  >查看</el-button
                >
                <el-button
                  class="btn"
                  size="mini"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <Pagination
        :total="total"
        :list="tableData"
        :page="screenData.pageIndex"
        :pageSize="screenData.pageSize"
        @change="changePage"
      />

      <!-- 编辑专题 -->
      <el-dialog
        :title="ruleName"
        :top="dialog_top"
        width="1200px"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <div class="topic_det">
          <!-- 不可编辑 -->
          <div>
            <div class="det_item">
              <span>专题id：</span>
              <p>{{ ruleDetails.ruleId }}</p>
            </div>
            <div class="det_item">
              <span>专题名称：</span>
              <p>{{ ruleDetails.ruleName }}</p>
            </div>
            <div class="det_item">
              <span>关键词：</span>
              <p>{{ ruleDetails.keywords }}</p>
            </div>
            <div class="det_item">
              <span>排除词：</span>
              <p>{{ ruleDetails.noKeywords }}</p>
            </div>
            <div class="det_item">
              <span>sun历史数据数量：</span>
              <p>{{ ruleDetails.saveSunCount }}</p>
            </div>
            <div class="det_item">
              <span>匹配模式：</span>
              <p>{{ matchModeObj[ruleDetails.matchMode] }}</p>
            </div>
            <div class="det_item">
              <span>站点类型：</span>
              <ul v-if="ruleDetails.siteTypes">
                <li
                  v-for="(site, index) in ruleDetails.siteTypes.split(',')"
                  :key="index"
                >
                  {{ siteObj[site] }}
                </li>
              </ul>
            </div>
            <div class="det_item">
              <span>情感：</span>
              <ul v-if="ruleDetails.sentiment">
                <li
                  v-for="(sentiment, index) in ruleDetails.sentiment.split(',')"
                  :key="index"
                >
                  {{ sentimentObj[sentiment] }}
                </li>
              </ul>
            </div>
            <div class="det_item">
              <span>域名：</span>
              <p>{{ ruleDetails.domains }}</p>
            </div>
            <div class="det_item">
              <span>添加时间：</span>
              <p>{{ ruleDetails.addOn }}</p>
            </div>
            <div class="det_item">
              <span>更新用户：</span>
              <p>{{ ruleDetails.updateUser }}</p>
            </div>
            <div class="det_item">
              <span>更新时间：</span>
              <p>{{ ruleDetails.updateOn }}</p>
            </div>
            <div class="det_item">
              <span>暂停时间：</span>
              <p>{{ ruleDetails.pauseTime }}</p>
            </div>
          </div>
          <!-- 可编辑 -->
          <div class="form_box">
            <el-form :model="editForm" :rules="rules" ref="editForm">
              <!-- 开始/结束时间 -->
              <el-form-item label="开始/结束时间：" prop="date">
                <el-date-picker
                  v-model="editForm.date"
                  class="date_box"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
              <!-- 状态 -->
              <el-form-item label="状态：">
                <el-radio v-model="editForm.status" :label="0">待运行</el-radio>
                <el-radio v-model="editForm.status" :label="1">运行中</el-radio>
                <el-radio v-model="editForm.status" :label="2">暂停</el-radio>
                <el-radio v-model="editForm.status" :label="3">已删除</el-radio>
              </el-form-item>
              <!-- 取接口历史数据 -->
              <el-form-item label="取接口历史数据：">
                <el-radio v-model="editForm.isSaveSunData" :label="1"
                  >不取</el-radio
                >
                <el-radio v-model="editForm.isSaveSunData" :label="0"
                  >允许取saveSunCount的数量</el-radio
                >
                <el-radio v-model="editForm.isSaveSunData" :label="3"
                  >无限制取</el-radio
                >
              </el-form-item>
              <!-- 取接口历史数据 -->
              <el-form-item label="接口历史取数状态：">
                <el-radio v-model="editForm.sunDataStatus" :label="0"
                  >待取</el-radio
                >
                <el-radio v-model="editForm.sunDataStatus" :label="1"
                  >已取完</el-radio
                >
                <el-radio v-model="editForm.sunDataStatus" :label="2"
                  >正在取</el-radio
                >
              </el-form-item>
              <!-- 取接口历史数据 -->
              <el-form-item label="sdk历史取数状态：">
                <el-radio v-model="editForm.sdkDataStatus" :label="0"
                  >待取</el-radio
                >
                <el-radio v-model="editForm.sdkDataStatus" :label="1"
                  >已取完</el-radio
                >
                <el-radio v-model="editForm.sdkDataStatus" :label="2"
                  >正在取</el-radio
                >
              </el-form-item>
              <!-- 接口取数 -->
              <el-form-item label="接口取数：">
                <el-switch
                  active-color="#525F7F"
                  active-value="是"
                  inactive-value="否"
                  v-model="editForm.sunordergather"
                ></el-switch>
              </el-form-item>
              <!-- 关键词匹配转发 -->
              <el-form-item label="关键词匹配转发：">
                <el-switch
                  active-color="#525F7F"
                  active-value="是"
                  inactive-value="否"
                  v-model="editForm.repostStatus"
                ></el-switch>
              </el-form-item>
              <!-- 过滤垃圾 -->
              <el-form-item label="过滤垃圾：">
                <el-switch
                  active-color="#525F7F"
                  active-value="是"
                  inactive-value="否"
                  v-model="editForm.isFilterAD"
                ></el-switch>
              </el-form-item>
              <!-- 取转发 -->
              <el-form-item label="取转发：">
                <el-switch
                  active-color="#525F7F"
                  active-value="是"
                  inactive-value="否"
                  v-model="editForm.weiboRepost"
                ></el-switch>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 编辑结束时间 -->
      <el-dialog
        title="编辑时间"
        top="15vh"
        :close-on-click-modal="false"
        :visible.sync="editTimeVisible"
        @close="cancelEditTime"
      >
        <el-form :model="editTimeForm" :rules="rules" ref="editTimeForm">
          <el-form-item label="专题时间" prop="newDate">
            <el-date-picker
              v-model="editTimeForm.newDate"
              class="date_box"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelEditTime">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="saveTime"
            >保 存</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import time from "../../../assets/js/time.js";

export default {
  data() {
    return {
      time,
      loading: false,
      btnLoading: false,
      total: 0,
      tableData: [],
      screenData: {
        ruleId: "", // 专题id
        ruleName: "", // 专题名称
        startTime: "", // 开始时间 yyyy-MM-dd HH:mm:ss
        endTime: "", // 结束时间 yyyy-MM-dd HH:mm:ss
        companyid: "", // 公司id
        sunordergather: "", // 是否采集接口取数数据;1=是、0=否
        isFilterAD: "", // 过滤垃圾；0=不过滤；1=过滤 默认值 1 不能为null
        repostStatus: "", // 关键词匹配转发；专题获取数据是否异步获取微博转发评论数据，0：获取，1：不获取
        weiboRepost: "", // 取转发；0：获取原创，不取转发数据     1：获取原创，获取转发数据
        endGatherDate: "", // 回采结束状态;0=结束；1=未结束
        status: "", // 运行状态 0为待运行，1为正常运行，2为暂停，4已过期,5未过期
        character: "", // 空格，逗号，句号，点
        pageIndex: 1,
        pageSize: 10
      },
      search_companyList: [], // 公司列表
      companyList: {}, // 公司列表
      table_height: 400,
      dialogFormVisible: false,
      is_add: true,
      ruleName: "",
      ruleDetails: {},
      // 表单
      ruleForm: {
        name: "",
        keywords: "",
        code: ""
      },
      // 表单检验规则
      rules: {
        revCrawlerTime: [
          { required: true, message: "请选择回采时间", trigger: "blur" }
        ],
        newDate: [{ required: true, message: "请选择时间", trigger: "blur" }],
        date: [{ required: true, message: "请选择时间", trigger: "blur" }]
      },
      row_index: 0,
      library_id: "",
      dialog_top: "15vh",
      is_init: false,

      changeStatus(status) {
        let name = "";
        switch (status) {
          case 0:
            name = "待运行";
            break;
          case 1:
            name = "正常运行";
            break;
          case 2:
            name = "暂停";
            break;
          case 3:
            name = "已删除";
            break;
        }
        return name;
      },
      date: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      options: [
        { value: "", label: "全部" },
        { value: 1, label: "是" },
        { value: 0, label: "否" }
      ],
      options2: [
        { value: "", label: "全部" },
        { value: 0, label: "结束" },
        { value: 1, label: "未结束" }
      ],
      options3: [
        { value: "", label: "全部" },
        { value: 1, label: "是" },
        { value: 0, label: "否" }
      ],
      stringArr: [],
      statusOptions: [
        { value: "", label: "全部" },
        { value: 0, label: "待运行" },
        { value: 1, label: "正常运行" },
        { value: 2, label: "暂停" },
        { value: 4, label: "过期" },
        { value: 5, label: "未过期" }
      ],
      editForm: {},

      editTimeVisible: false,
      end_time: "",
      start_time: "",
      editTimeForm: {
        newDate: []
      },
      rowItem: {},
      // 设置今天之前不可选
      startDateLimit: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      siteObj: {},
      sentimentObj: {
        "-1": "负面",
        "0": "中性",
        "1": "正面"
      },
      matchModeObj: {
        "1": "标题加正文",
        "2": "仅标题",
        "3": "仅正文"
      }
    };
  },
  computed: {
    authority() {
      return this.$route.meta.authority;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    companyId() {
      return this.$store.state.companyId;
    }
  },
  watch: {
    date(e) {
      if (!e) {
        this.screenData.startTime = "";
        this.screenData.endTime = "";
        this.screening();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.changeTableHeight("init");
    });

    window.onresize = () => {
      this.changeTableHeight("onresize");
    };
    this.getCompanyList();
    this.getSiteTypes();
    this.getString();
  },
  methods: {
    // 获取专题列表
    getClassList() {
      if (!this.authority) return;
      this.loading = true;
      this.$refs.table.bodyWrapper.scrollTop = 0;
      if (!this.isAdmin) this.screenData.companyid = this.companyId;
      this.$http({
        url: this.$api.class_list,
        data: this.screenData
      }).then(res => {
        this.loading = false;
        this.is_init = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
        } else {
          this.total = 0;
          this.tableData = [];
        }
      });
    },
    // 获取公司列表
    getCompanyList() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          if (this.isAdmin) {
            this.search_companyList = res.data;
            this.search_companyList.unshift({
              companyid: "0",
              companyname: "全部"
            });
            res.data.forEach(val => {
              this.companyList[val.companyid] = val.companyname;
            });
          } else {
            res.data.forEach(val => {
              if (val.companyid == this.companyId) {
                this.search_companyList = [val];
                this.companyList[val.companyid] = val.companyname;
              }
            });
          }
        }
      });
    },
    // 获取所有信源
    getSiteTypes() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.siteType,
        data: {}
      }).then(res => {
        if (res.code == 0) {
          this.siteObj = res.data || {};
        }
      });
    },
    // 获取字符筛选
    getString() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.characters,
        data: {}
      }).then(res => {
        if (res.code == 0) {
          this.stringArr = [];
          res.data.forEach(item => {
            this.stringArr.push({
              value: item.value,
              label: item.key
            });
          });
        }
      });
    },

    // 编辑专题
    editClassReq(type = "") {
      this.btnLoading = true;
      let data = {};
      if (type == "time") {
        data = this.rowItem;
      } else {
        data = {
          isFilterAD: this.editForm.isFilterAD == "是" ? 1 : 0,
          repostStatus: this.editForm.repostStatus == "否" ? 0 : 1,
          weiboRepost: this.editForm.weiboRepost == "是" ? 1 : 0,
          sunordergather: this.editForm.sunordergather == "是" ? 1 : 0,
          revCrawlerTime: this.editForm.revCrawlerTime,
          ruleId: this.editForm.ruleId,
          startTime: this.editForm.date[0],
          endTime: this.editForm.date[1],
          status: this.editForm.status,
          isSaveSunData: this.editForm.isSaveSunData,
          sunDataStatus: this.editForm.sunDataStatus,
          sdkDataStatus: this.editForm.sdkDataStatus
        };
      }
      this.$http({
        url: this.$api.edit_class,
        data
      }).then(res => {
        this.btnLoading = false;
        if (res.code == 0) {
          type == "time" ? this.cancelEditTime() : this.getClassList();
          this.$hint("保存成功");
        } else {
          this.$hint("保存失败", "err");
        }
      });
    },
    // 选择公司
    selectCompany(e) {
      e == "0"
        ? (this.screenData.companyid = "")
        : (this.screenData.companyid = e);
      this.screening();
    },

    // 翻页
    changePage(e) {
      this.screenData.pageIndex = e;
      this.getClassList();
    },

    // 编辑专题
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.row_index = index;
      this.ruleName = row.ruleName;
      this.ruleDetails = row;
      let obj = {
        isFilterAD: row.isFilterAD == 1 ? "是" : "否",
        repostStatus: row.repostStatus == 0 ? "否" : "是",
        weiboRepost: row.weiboRepost == 1 ? "是" : "否",
        sunordergather: row.sunordergather == 1 ? "是" : "否",
        revCrawlerTime: row.revCrawlerTime,
        ruleId: row.ruleId,
        endTime: row.endTime,
        status: row.status,
        isSaveSunData: row.isSaveSunData,
        sunDataStatus: row.sunDataStatus,
        sdkDataStatus: row.sdkDataStatus,
        date: [row.startTime, row.endTime]
      };
      this.editForm = obj;
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.is_add) {
          } else {
            // 编辑
            this.editClassReq();
          }
          this.cancel();
        } else {
          return false;
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.editForm.resetFields();
    },
    // 选择日期
    selectDate(e) {
      if (Boolean(e)) {
        this.screenData.startTime = e[0];
        this.screenData.endTime = e[1];
        this.screening();
      }
    },
    // 选择过滤
    selectScrenn(e) {
      this.screening();
    },
    // 筛选
    screening() {
      this.screenData.pageIndex = 1;
      this.getClassList();
    },
    // 打开编辑结束时间
    editEndTime(row) {
      this.editTimeVisible = true;
      this.editTimeForm.newDate = [row.startTime, row.endTime];
      this.rowItem = row;
    },
    // 保存结束时间
    saveTime() {
      this.$refs.editTimeForm.validate(valid => {
        if (valid) {
          let end_date = new Date(this.editTimeForm.newDate[1]).getTime();
          let now_date = new Date().getTime();
          if (end_date < now_date) {
            this.$hint("结束时间不能少于当前时间", "err");
            return;
          }
          this.rowItem.startTime = this.editTimeForm.newDate[0];
          this.rowItem.endTime = this.editTimeForm.newDate[1];
          this.editClassReq("time");
        } else {
          return false;
        }
      });
    },
    // 关闭编辑时间
    cancelEditTime() {
      this.editTimeVisible = false;
    },
    // 查看专题
    lookTopic(row) {
      let startTime = this.time(0, "YY-MM-DD") + " 00:00:00";
      let endTime = this.time(0);
      let params = {
        init: true,
        ruleName: row.ruleName,
        ruleId: row.ruleId,
        date: [startTime, endTime],
        uDate: [startTime, endTime],
        sourceType: [1, 2],
        recordType: ["normal", "ad", "dirty"],
        siteTypes: row.siteTypes.split(","),
        countType: ["all"]
      };
      this.$store.state.topicData = params;
      this.$router.push("/classStatistics");
    },
    // 计算表格高度
    changeTableHeight(type) {
      let height = document.getElementById("table_list").offsetHeight;
      if (type == "onresize" && this.table_height == height) return;
      this.table_height = height;
      if (this.table_height < 550) {
        this.dialog_top = "5vh";
        this.screenData.pageSize = 10;
      } else {
        this.dialog_top = "15vh";
        this.screenData.pageSize = 20;
      }
      this.screenData.pageIndex = 1;
      this.getClassList();
    }
  }
};
</script>

<style lang="less" scoped>
.head {
  padding-right: 0;
  .screening_box {
    width: 100%;
    align-items: flex-start;
    border: 1px solid #eee;
    border-radius: 5px;
    background: #fafafa;
    > div {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      > ul {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding-right: 10px;
        box-sizing: border-box;
        > li {
          display: flex;
          align-items: center;
          margin-left: 15px;
          > span {
            font-size: 13px;
            color: #999;
            white-space: nowrap;
          }
          .date_box {
            width: 370px;
            /deep/ .el-range__icon {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            /deep/ .el-range-separator {
              display: flex;
              align-items: center;
              justify-content: center;
            }
            /deep/ .el-range__close-icon {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
}

.btn_box {
  display: flex;
  .btn {
    padding: 0;
    border: none;
  }
}

.selectBox {
  width: 85px;
  /deep/ .el-input {
    .el-input__inner {
      width: 75px;
      font-size: 12px;
    }
  }
}
.selectBox2 {
  width: 120px;
  /deep/ .el-input {
    .el-input__inner {
      width: 110px;
      font-size: 12px;
    }
  }
}
.paging_box {
  margin: 0;
}

.edit_icon {
  cursor: pointer;
  &:hover {
    color: #000;
  }
}

.topic_det {
  display: flex;
  > div {
    width: 0;
    flex: 1;
    border-right: 1px solid #eee;
    padding: 0 20px;
    box-sizing: border-box;
    &:nth-last-child(1) {
      border: none;
    }
    .det_item {
      display: flex;
      font-size: 14px;
      color: #525f7f;
      margin-bottom: 15px;
      > span {
        color: #777;
        font-size: 13px;
        white-space: nowrap;
      }
      > p {
        font-weight: bold;
      }
      > ul {
        display: flex;
        font-weight: bold;
        flex-wrap: wrap;
        > li {
          margin-right: 10px;
        }
      }
    }
  }
  .form_box {
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-radio {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/topicManage.vue